import { Navigate } from 'react-router-dom';
import { EmptyState } from '@/components/shared/empty-state';
import { useEntitlements } from '@/lib/entitlements';

/** `/` has no screen of its own: it lands on the first module the plan includes. */
export function HomeRedirect() {
  const { navModules, enabledModules, muestra } = useEntitlements();
  // La primera del menú, que es donde la persona iría sola. El respaldo es para
  // el caso raro en que todo esté escondido: mandarla a un módulo que tiene pero
  // no ve es mejor que dejarla en una pantalla de error con la sesión abierta.
  //
  // Nunca a un módulo que no se puede dibujar —hoy, Leads sin tablero—: esa ruta
  // contesta «sin acceso» y su salida es «ir a lo que sí tienes», o sea acá, y
  // quedarían rebotando. «Tiene pero no ve» y «no se puede dibujar» son cosas
  // distintas, y la segunda la contesta `muestra`: preguntarle a él en vez de
  // nombrar a Leads acá es lo que hace que el próximo caso no haya que agregarlo.
  const first = navModules[0] ?? enabledModules.find((module) => muestra({ modulo: module.id }));

  if (!first) {
    return (
      <EmptyState
        variant="no-access"
        title="Tu organización no tiene módulos habilitados"
        description="Nadie puede entrar a una pantalla todavía. Quien administra la cuenta debe encender al menos un módulo en Configuración → Módulos."
      />
    );
  }

  return <Navigate to={first.path} replace />;
}
